module.exports = __webpack_public_path__ + "static/img/main_bg.40ce58b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main_bg.jpg
// module id = xc/o
// module chunks = 4